import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/components/ui';

/** Copies a value and toasts the outcome, naming what was copied when a label is given. */
export function useCopyToClipboard() {
    const { t } = useTranslation();
    const toast = useToast();
    return useCallback(
        (value: string, label?: string) => {
            void navigator.clipboard.writeText(value).then(
                () =>
                    toast.success(
                        label
                            ? t('console.appDetail.connection.copiedNamed', { label })
                            : t('console.appDetail.connection.copied')
                    ),
                () => toast.error(t('console.appDetail.connection.copyFailed'))
            );
        },
        [t, toast]
    );
}
